<template lang="pug">
  div.wrap-item-user-profile.py20
    div.f.flex-between
      div.wrap-icon.pr10
        div.wrap-img.f.fh
          img(:src="user.iconURL")
      div.user-content.f.fm.flex-between
        div
          span.name {{user.name}}
          span.profile {{user.profile}}
        span(@click="logout").logout ログアウト
    //- div.wrap-minna-rate.mt4
      span {{`${avatar.typeName}度：${point}`}}
</template>

<style lang="scss" scoped>
.wrap-item-user-profile {
  width: 92%;
  margin: 0 auto;
  max-width: 620px;
  .wrap-icon {
    .wrap-img {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      overflow: hidden;
      img {
        object-fit: cover;
        width: 100%;
      }
    }
  }
  .user-content {
    width: calc(100% - 64px);
    span {
      display: block;
    }
    .profile {
      color: #999;
      font-size: 12px;
    }
    .logout {
      color: #e0245e;
      font-size: 12px;
    }
  }
  .wrap-minna-rate {
    span {
      display: block;
      text-align: center;
    }
  }
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'

const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')

export default {
  components: {

  },
  computed: {
    ...mapStateAuth([
      'uid',
      'isAnonymous'
    ])
  },
  props: {
    user: {
      type: Object,
      require: true
    },
    avatar: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      point: 0
    }
  },
  async created () {
    var user = this.user
    this.point = user.alikePoint + user.likePoint + user.retweetPoint + user.postPoint - user.unlikePoint
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    logout () {
      this.signOut()
      setTimeout(() => {
        this.$router.push('/sign-in')
      }, 400)
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    }
  }
}
</script>
